import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/site/Home";
import Blog from "@/pages/site/Blog";
import Article from "@/pages/site/Article";
import ChiSiamo from "@/pages/site/ChiSiamo";
import Contatti from "@/pages/site/Contatti";
import Legal from "@/pages/site/Legal";
import Preventivo from "@/pages/site/Preventivo";
import Confronta from "@/pages/site/Confronta";
import Consulenza from "@/pages/site/Consulenza";
import Razza, { Razze } from "@/pages/site/Razza";
import CittaPage, { Citta } from "@/pages/site/Citta";
import Login from "@/pages/admin/Login";
import DashboardLayout from "@/components/admin/DashboardLayout";
import Today from "@/pages/admin/Today";
import Kpi from "@/pages/admin/Kpi";
import Crm from "@/pages/admin/Crm";
import ContentEngine from "@/pages/admin/ContentEngine";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import Affiliates from "@/pages/admin/Affiliates";
import Settings from "@/pages/admin/Settings";
import { ComingSoon, Newsletter } from "@/pages/admin/Modules";
import Keywords from "@/pages/admin/Keywords";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/preventivo" element={<Preventivo />} />
            <Route path="/confronta" element={<Confronta />} />
            <Route path="/consulenza" element={<Consulenza />} />
            <Route path="/razze" element={<Razze />} />
            <Route path="/razze/:slug" element={<Razza />} />
            <Route path="/citta" element={<Citta />} />
            <Route path="/citta/:slug" element={<CittaPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Article />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/:page" element={<Legal />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Today />} />
            <Route path="kpi" element={<Kpi />} />
            <Route path="crm" element={<Crm />} />
            <Route path="content" element={<ContentEngine />} />
            <Route path="content/:id" element={<ArticleEditor />} />
            <Route path="affiliates" element={<Affiliates />} />
            <Route path="settings" element={<Settings />} />
            <Route path="newsletter" element={<Newsletter />} />
            <Route path="video" element={<ComingSoon kind="video" />} />
            <Route path="broker" element={<ComingSoon kind="broker" />} />
            <Route path="seo" element={<Keywords />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
